import { render } from "./message-audio.vue?vue&type=template&id=5e652b2c&scoped=true&ts=true"
import script from "./message-audio.vue?vue&type=script&lang=ts"
export * from "./message-audio.vue?vue&type=script&lang=ts"

import "./message-audio.vue?vue&type=style&index=0&id=5e652b2c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e652b2c"]])

export default __exports__